
class AnalyticAccountViewController extends MUIViewController implements AnalyticAccountCellDelegate
{
    static newInstance() : AnalyticAccountViewController {
        let vc = new AnalyticAccountViewController('analytic-account-view');
        vc.initWithResource('layout/analytic_accounts/AnalyticAccountView.html');

        return vc;
    }

    private addButton:MUIButton = null;
    private saveButton:MUIButton = null;
    private tableView:UITableView = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.addButton = MUIOutlet(this, 'add-btn', 'MUIButton');
        this.addButton.setAction(this, function(){
            this.addAccount(null);
        });

        this.saveButton = MUIOutlet(this, 'save-btn', 'MUIButton');
        this.saveButton.setAction(this, function(){
            DBHelper.saveMainContext();
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(animated?){
        super.viewWillAppear(animated);
        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        this.fetchedResultsController = null;
        this.reloadTreeItems();
        this.tableView.reloadData();
    }

    numberOfSections(tableview:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableview:UITableView, section:number){
        return this.treeItems.length;
    }

    cellAtIndexPath(tableview:UITableView, indexPath:MIOIndexPath){
        let cell = tableview.dequeueReusableCellWithIdentifier('AnalyticAccountCell') as AnalyticAccountCell;
        let item = this.treeItems[indexPath.row];
        cell.delegate = this;
        cell.item = item;
        cell.selectionStyle = UITableViewCellSelectionStyle.None;

        return cell;
    }

    editingStyleForRowAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        return UITableViewCellEditingStyle.Delete;
    }

    commitEditingStyleForRowAtIndexPath(tableView:UITableView, editingStyle:UITableViewCellEditingStyle, indexPath:MIOIndexPath) {
        let item = this.treeItems[indexPath.row];

        if (editingStyle == UITableViewCellEditingStyle.Delete) {
            this.deleteAccount(item);
        }
    }

    // The server only accepts real model attributes as sort keys, so the fetch is sorted
    // by name and the tree order (each account right below its parent) is built in memory.
    private treeItems:AnalyticAccount[] = [];
    private reloadTreeItems(){
        let objects = this.fetchedResultsController.fetchedObjects;

        let roots = [];
        let childrenByParent = {};
        for (let index = 0; index < objects.length; index++){
            let account = objects[index] as AnalyticAccount;
            let parent = account.parent;
            if (parent == null) {
                roots.push(account);
            }
            else {
                if (childrenByParent[parent.identifier] == null) childrenByParent[parent.identifier] = [];
                childrenByParent[parent.identifier].push(account);
            }
        }

        let items = [];
        let appendBranch = function(account:AnalyticAccount){
            items.push(account);
            let children = childrenByParent[account.identifier];
            if (children == null) return;
            for (let index = 0; index < children.length; index++){
                appendBranch(children[index]);
            }
        };

        for (let index = 0; index < roots.length; index++){
            appendBranch(roots[index]);
        }

        this.treeItems = items;
    }

    addChildDidPress(cell:AnalyticAccountCell, account:AnalyticAccount){
        this.addAccount(account);
    }

    changeParentDidPress(cell:AnalyticAccountCell, account:AnalyticAccount){
        this.changeParent(account);
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;

        this._fetchedResultsController = value;
    }

    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;

        let ad = MUIWebApplication.sharedInstance().delegate;

        let sortDescriptors = [MIOSortDescriptor.sortDescriptorWithKey('title', true)];
        let fetchRequest = DBHelper.listFetchRequestWithEntityName("AnalyticAccount", sortDescriptors, null);
        fetchRequest.relationshipKeyPathsForPrefetching = ['parent', 'children', 'ledgerAccount'];

        let fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;

        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;
        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller){
        this.reloadTreeItems();
        this.tableView.reloadData();
    }

    private addAccount(parent:AnalyticAccount){
        let avc = new MUIAlertViewController();
        let title = parent == null ? MIOLocalizeString("NEW_ANALYTIC_ACCOUNT", "NEW ANALYTIC ACCOUNT") : MIOLocalizeString("NEW_CHILD_ANALYTIC_ACCOUNT", "NEW CHILD ANALYTIC ACCOUNT") + ": " + parent.title;
        avc.initWithTitle(title, MIOLocalizeString("CHOOSE_A_NAME", "CHOOSE A NAME"), MUIAlertViewStyle.Default);
        avc.addTextFieldWithConfigurationHandler(this, function(textField:MUITextField){
            textField.setPlaceholderText(MIOLocalizeString("NAME","NAME"));
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('ADD','ADD'), MUIAlertActionStyle.Default, this, function(){
            let name = avc.textFields[0].text.trim();

            if (name.length > 0){
                this.createAccount(name, parent);
            }
            else {
                let error = new MUIAlertViewController();
                error.initWithTitle(MIOLocalizeString('ERROR', 'ERROR'), MIOLocalizeString("CHECK_NAME", "CHECK NAME"), MUIAlertViewStyle.Default);
                error.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CLOSE','CLOSE'), MUIAlertActionStyle.Cancel, this, function(){}));

                this.presentViewController(error, true);
            }
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, this, function(){}));

        this.presentViewController(avc, true);
    }

    private createAccount(name:string, parent:AnalyticAccount){
        let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;

        let predicate = MIOPredicate.predicateWithFormat(parent != null ? "parent.identifier == '" + parent.identifier + "'" : "parent == null");
        let siblings = DBHelper.queryObjectsFromMainContext("AnalyticAccount", null, predicate);

        let account = MIOEntityDescription.insertNewObjectForEntityForName("AnalyticAccount", moc) as AnalyticAccount;
        account.identifier = MIOUUID.UUID().UUIDString;
        account.title = name;
        account.parent = parent;
        account.indexPath = parent != null ? parent.indexPath + "." + siblings.length : siblings.length.toString();
        moc.save();
    }

    private changeParent(account:AnalyticAccount){
        // Build the indented list of eligible parents: every account except the one
        // being moved and its descendants, since those would create a cycle
        let objects = this.fetchedResultsController.fetchedObjects;

        let roots = [];
        let childrenByParent = {};
        for (let index = 0; index < objects.length; index++){
            let item = objects[index] as AnalyticAccount;
            let parent = item.parent;
            if (parent == null) {
                roots.push(item);
            }
            else {
                if (childrenByParent[parent.identifier] == null) childrenByParent[parent.identifier] = [];
                childrenByParent[parent.identifier].push(item);
            }
        }

        let accounts:AnalyticAccount[] = [];
        let levels:number[] = [];
        let appendBranch = function(item:AnalyticAccount, level:number){
            if (item.identifier == account.identifier) return;
            accounts.push(item);
            levels.push(level);
            let children = childrenByParent[item.identifier];
            if (children == null) return;
            for (let index = 0; index < children.length; index++){
                appendBranch(children[index], level + 1);
            }
        };

        for (let index = 0; index < roots.length; index++){
            appendBranch(roots[index], 0);
        }

        let avc = new MUIAlertViewController();
        avc.initWithTitle(MIOLocalizeString("CHANGE_PARENT", "CHANGE PARENT") + ": " + account.title, MIOLocalizeString("CHOOSE_A_PARENT", "CHOOSE A PARENT"), MUIAlertViewStyle.Default);

        avc.addComboBoxWithConfigurationHandler(this, function(comboBox:MUIComboBox){
            comboBox.removeAllItems();
            comboBox.addItem(MIOLocalizeString("NO_PARENT_ROOT_ACCOUNT", "NO PARENT (ROOT ACCOUNT)"), -1);
            let selectedIndex = -1;
            for (let index = 0; index < accounts.length; index++){
                let indent = "";
                for (let level = 0; level < levels[index]; level++) indent += "   ";
                comboBox.addItem(indent + accounts[index].title, index);
                if (account.parent != null && account.parent.identifier == accounts[index].identifier) selectedIndex = index;
            }
            comboBox.selectItem(selectedIndex);
        });

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('OK','OK'), MUIAlertActionStyle.Default, this, function(){
            let parentIndex = parseInt(avc.comboBoxes[0].getSelectedItem());
            let parent = parentIndex >= 0 ? accounts[parentIndex] : null;

            let currentParentID = account.parent != null ? account.parent.identifier : null;
            let newParentID = parent != null ? parent.identifier : null;
            if (currentParentID == newParentID) return;

            this.setAccountParent(account, parent);
        }));

        avc.addAction(MUIAlertAction.alertActionWithTitle(MIOLocalizeString('CANCEL','CANCEL'), MUIAlertActionStyle.Cancel, this, function(){}));

        this.presentViewController(avc, true);
    }

    private setAccountParent(account:AnalyticAccount, parent:AnalyticAccount){
        let moc = MUIWebApplication.sharedInstance().delegate.managedObjectContext;

        let predicate = MIOPredicate.predicateWithFormat(parent != null ? "parent.identifier == '" + parent.identifier + "'" : "parent == null");
        let siblings = DBHelper.queryObjectsFromMainContext("AnalyticAccount", null, predicate);

        account.parent = parent;
        account.indexPath = parent != null ? parent.indexPath + "." + siblings.length : siblings.length.toString();
        moc.save();
    }

    private deleteAccount(delObject:AnalyticAccount) {
        // Reconnect the children to the parent of the deleted account so the subtree is not lost
        let predicate = MIOPredicate.predicateWithFormat("parent.identifier == '" + delObject.identifier + "'");
        DBHelper.queryObjectsWithCompletion("AnalyticAccount", null, predicate, ['children', 'parent'], this, function(objects){

            for (let index = 0; index < objects.length; index++){
                objects[index].parent = delObject.parent != null ? delObject.parent : null;
            }

            DBHelper.deleteObjectFromMainContext(delObject, true);
        });
    }
}
